import {
  INIT_URL,
  FETCH_TIMELINE_LOG_START,
  FETCH_TIMELINE_LOG_SUCCESS,
  FETCH_TIMELINE_LOG_ERROR,
  FETCH_TIMELINE_LOGS_START,
  FETCH_TIMELINE_LOGS_SUCCESS,
  FETCH_TIMELINE_LOGS_ERROR,
  CHANGE_PAGE_LIMIT,
  CHANGE_PAGE,
} from '../../constants/ActionTypes';

const INIT_STATE = {
  token: localStorage.getItem('token'),
  registrationToken: null,
  initURL: '',
  authUser: JSON.parse(localStorage.getItem('user')),
  timeline_logs: {
    data: [],
    loading: false,
    error: null,
    currentPage: 1,
    pageSize: 10,
    totalRecords: 1,
  },
  timeline_log: {
    data: null,
    loading: false,
    error: null,
  },
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case INIT_URL: {
      return { ...state, initURL: action.payload };
    }

    case FETCH_TIMELINE_LOG_START: {
      return {
        ...state,
        timeline_log: {
          ...state.timeline_log,
          loading: true,
        },
      };
    }

    case FETCH_TIMELINE_LOG_SUCCESS: {
      return {
        ...state,
        timeline_log: {
          ...state.timeline_log,
          loading: false,
          data: action.payload,
        },
      };
    }

    case FETCH_TIMELINE_LOG_ERROR: {
      return {
        ...state,
        timeline_log: {
          ...state.timeline_log,
          loading: false,
          error: action.payload,
        },
      };
    }

    case FETCH_TIMELINE_LOGS_START: {
      return {
        ...state,
        timeline_logs: {
          ...state.timeline_logs,
          loading: true,
        },
      };
    }

    case FETCH_TIMELINE_LOGS_SUCCESS: {
      return {
        ...state,
        timeline_logs: {
          ...state.timeline_logs,
          loading: false,
          data: action.payload,
          currentPage: action.currentPage,
          totalRecords: action.totalRecords,
        },
      };
    }

    case FETCH_TIMELINE_LOGS_ERROR: {
      return {
        ...state,
        timeline_logs: {
          ...state.timeline_logs,
          loading: false,
          error: action.payload,
        },
      };
    }

    case CHANGE_PAGE_LIMIT: {
      return {
        ...state,
        [action.payload.type]: {
          ...state[action.payload.type],
          pageSize: action.payload.pageSize,
        },
      };
    }

    case CHANGE_PAGE: {
      return {
        ...state,
        [action.payload.type]: {
          ...state[action.payload.type],
          currentPage: action.payload.currentPage,
        },
      };
    }

    default:
      return state;
  }
};
